<!--
 * @Description: 中位数、众数、四分位数分析表格
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="130" :itemWidth="420 + 56">
      <div
        style="text-align: center"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
      >
        <BaseCard style="width: 420px; height: 120px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            style="height: 86px !important"
            :value="item.value"
            :model-value="curItem.value"
            @change="onChangeFn(item.value)"
          >
            <component
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: center 0;
              "
              :is="cmpName(item.value)"
              :tableHeaderList="data_4_3.medianTable.header"
              :tableDataList="data_4_3.medianTable.value"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
    <div class="bi-tmpl-detail__right__cmpt__des">
      {{ data_4_3.resultSystemMedian }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import PcModuleTaskAnalysis from '@V/bi-tmpl/src/components/bi-pc-module/pc-module-task-analysis';

import { BaseCard } from 'xrk-components';
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import _ from 'lodash';
import { data_4_3 } from '../../../../hooks/use-preview';

const CHILD_KEY = '5_4';
const TYPE_MAPPING = {
  1: {
    value: 'pc-module-task-analysis-1',
    moduleType: 'pc-module-task-analysis-1'
  },
  2: {
    value: 'pc-module-task-analysis-2',
    moduleType: 'pc-module-task-analysis-2'
  },
  3: {
    value: 'pc-module-task-analysis-3',
    moduleType: 'pc-module-task-analysis-3'
  },
  4: {
    value: 'pc-module-task-analysis-4',
    moduleType: 'pc-module-task-analysis-4'
  },
  5: {
    value: 'pc-module-task-analysis-5',
    moduleType: 'pc-module-task-analysis-5'
  },
  6: {
    value: 'pc-module-task-analysis-6',
    moduleType: 'pc-module-task-analysis-6'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
const cmpName = name => {
  return PcModuleTaskAnalysis.filter(comp => comp.__name === name)[0];
};
const onChangeFn = _.debounce(val => {
  if (curItem.value === val) {
    onChange(null);
  } else {
    onChange(val);
  }
}, 0);
</script>
